import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';

import { webObservability } from './observability';

export function createAppQueryClient() {
  return new QueryClient({
    mutationCache: new MutationCache({
      onError(error, _variables, _context, mutation) {
        const context = getMutationContext(mutation.options.mutationKey);
        webObservability.captureException(error, {
          extra: {
            mutationKey: mutation.options.mutationKey,
          },
          tags: {
            domain: context.domain,
            operation: `mutation:${context.operation}`,
          },
        });
      },
    }),
    queryCache: new QueryCache({
      onError(error, query) {
        const context = getQueryContext(query.queryKey);
        webObservability.captureException(error, {
          extra: {
            queryHash: query.queryHash,
            queryKey: query.queryKey,
          },
          tags: {
            domain: context.domain,
            operation: `query:${context.operation}`,
          },
        });
      },
    }),
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: 2,
        retryDelay: (attemptIndex) =>
          Math.min(1_000 * 2 ** attemptIndex, 8_000),
        staleTime: 5_000,
      },
    },
  });
}

function getMutationContext(mutationKey: readonly unknown[] | undefined) {
  const domain =
    typeof mutationKey?.[0] === 'string' ? mutationKey[0] : 'mutation';
  const operation =
    typeof mutationKey?.[1] === 'string' ? mutationKey[1] : 'run';

  return {
    domain,
    operation,
  };
}

function getQueryContext(queryKey: readonly unknown[]) {
  const domain = typeof queryKey[0] === 'string' ? queryKey[0] : 'query';
  const operation = typeof queryKey[1] === 'string' ? queryKey[1] : 'fetch';

  return {
    domain,
    operation,
  };
}
